<section class="tp-error-area pt-75 pb-110">
    <div *ngIf="instruction" class="row">
        <vb-bidding-instruction-display [instruction]="instruction" class="offset-xxl-9 col-xxl-3" />
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-xl-6 col-lg-8 col-md-10">
                <div class="max-w-6xl">
                    <div
                        [innerHtml]="getPrivacyTxt"
                        class="dynamic-content"></div>
                </div>
            </div>
        </div>
    </div>
</section>
